import React, { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Store } from "lucide-react";

export function SecureImage({ fileId, alt = "", className = "", fallback }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let active = true;
    let objUrl = null;
    if (!fileId) {
      setSrc(null);
      return;
    }
    api
      .get(`/files/${fileId}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        objUrl = URL.createObjectURL(res.data);
        setSrc(objUrl);
      })
      .catch(() => active && setErr(true));
    return () => {
      active = false;
      if (objUrl) URL.revokeObjectURL(objUrl);
    };
  }, [fileId]);

  if (!fileId || err) {
    return (
      fallback || (
        <div className={`flex items-center justify-center bg-[#F4F0EA] text-[#84A98C] ${className}`}>
          <Store className="h-1/3 w-1/3" strokeWidth={1.5} />
        </div>
      )
    );
  }
  if (!src) return <div className={`animate-pulse bg-[#EDE8DF] ${className}`} />;
  return <img src={src} alt={alt} className={className} />;
}

export const assetFileUrl = fileUrl;
